import React, { useEffect, useState } from "react";
import { MapPin, Phone, Clock } from "lucide-react";
import { business } from "../data/siteData";
import api from "../lib/api";

export default function LocationCard({ className = "" }) {
  const [hours, setHours] = useState(business.hours);
  useEffect(() => {
    api
      .get("/site/config")
      .then(({ data }) => {
        if (Array.isArray(data?.hours) && data.hours.length) setHours(data.hours);
      })
      .catch(() => {});
  }, []);

  return (
    <div className={`border border-neutral-200 bg-white p-7 shadow-sm ${className}`}>
      <h3 className="mr-h3 text-xl">{business.name}</h3>
      <div className="mt-4 flex items-start gap-3">
        <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-[#a10000]" />
        <address className="not-italic leading-relaxed text-[#575757]">
          {business.address.line1}
          <br />
          {business.address.line2}
          <br />
          {business.address.city}, {business.address.state} {business.address.zip}
        </address>
      </div>
      <a
        href={business.directionsUrl}
        target="_blank"
        rel="noreferrer"
        className="mt-4 inline-block bg-[#244aa2] px-5 py-2.5 text-[12px] font-bold uppercase tracking-wide text-white transition-colors duration-200 hover:bg-[#0c2a66]"
      >
        Get Directions
      </a>

      <div className="mt-6 border-t border-neutral-200 pt-5">
        <h4 className="font-head text-sm font-extrabold uppercase tracking-widest text-[#242424]">
          Call Us
        </h4>
        <a
          href={`tel:${business.phoneRaw}`}
          className="mt-2 inline-flex items-center gap-2 text-lg font-bold text-[#244aa2] transition-colors hover:text-[#a10000]"
        >
          <Phone className="h-4 w-4" /> {business.phone}
        </a>
      </div>

      <div className="mt-6 border-t border-neutral-200 pt-5">
        <h4 className="font-head flex items-center gap-2 text-sm font-extrabold uppercase tracking-widest text-[#242424]">
          <Clock className="h-4 w-4 text-[#a10000]" /> Hours
        </h4>
        <ul className="mt-3 space-y-1.5 text-sm">
          {hours.map((h) => (
            <li key={h.day} className="flex justify-between gap-4">
              <span className="font-bold text-[#242424]">{h.day}:</span>
              <span className={/closed/i.test(h.value) ? "text-[#a10000]" : "text-[#575757]"}>
                {h.value}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
